import React from 'react';
import {TextField} from "@mui/material";

const SingleDay = (props) => {
    return (
        <TextField
            id="date"
            label="Дата"
            type="date"
            defaultValue= {new Date()}
            sx={{width: 220}}
            InputLabelProps={{
                shrink: true,
            }}
            sx={{width: '100%'}}
            {...props}
            color="secondary"
        />
    );
};

export default SingleDay;